import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HbNotification } from '../notification';
import { NotificationState } from '../notification-state';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'hb-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit, OnDestroy {
  private mutationObserverConfig = {
    attributes: true,
    childList: true,
    subtree: true,
  };
  private observer: MutationObserver;

  public notificationState = NotificationState;

  @Input() notification: HbNotification;

  constructor(
    private router: Router,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.observer = new MutationObserver(this.callback);
  }

  navigate(url: any[], op) {
    this.router.navigate(url);
    op.hide();
  }

  callback = (mutationsList: any) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        if (mutation.addedNodes[0] != null) {
          mutation.addedNodes[0].style.position = 'fixed';
        }
      }
    }
  };

  // show/hide the actions overlay panel
  actionsToggle($event, overlayPanel) {
    const element = overlayPanel.el.nativeElement;
    this.observer.observe(element, this.mutationObserverConfig);
    overlayPanel.toggle($event);
  }

  removeNotification() {
    this.notificationService.removeNotification(this.notification);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
